import { ReactNode, memo } from "react";
import Error from "./Error";
import Loading from "./Loading";
import useProgress from "../../utility/useProgress";


function LoadingErrorContainer({
  isError,
  isLoading,
  isRefetching,
  children,
}) {

  useProgress({
    isRefetching
  })
  return (
    <>{isError ? <Error /> : isLoading ? <Loading size={18} /> : children}</>
  );
}

export default memo(LoadingErrorContainer);
